import React from 'react';
import { connect } from 'react-redux';

import { Form, InputGroup } from 'react-bootstrap-5';
import { setFilterAttribute } from '../../../store/actions/criteria';
import CriteriaDecorator from '../../../helpers/criteria_decorator';

interface RangeInputProps {
  addOn?: React.ReactNode,
  criteria: {
    assetClassIds: number[]
  },
  float?: boolean,
  maxAttribute: string,
  minAttribute: string,
  percent?: boolean,
  placeholder: string,
  setFilterAttribute: (attribute: string, value: string, options: {
    float?: boolean,
    int?: boolean,
    percent?: boolean,
    array?: boolean,
    debounce?: boolean
  }) => void
}

function RangeInput({
  criteria,
  float,
  maxAttribute,
  minAttribute,
  percent,
  placeholder,
  addOn,
  setFilterAttribute
}: RangeInputProps) {
  const decoratedCriteria = new CriteriaDecorator(criteria);
  const minValue = decoratedCriteria[minAttribute] ? decoratedCriteria[minAttribute]() : criteria[minAttribute];
  const maxValue = decoratedCriteria[maxAttribute] ? decoratedCriteria[maxAttribute]() : criteria[maxAttribute];
  const isFloat = float || percent;
  const allowPrependZero = isFloat && (minValue === 0 || maxValue === 0);

  return (
    <div className="d-flex align-items-center">
      <InputGroup>
        { addOn && <InputGroup.Text>{addOn}</InputGroup.Text> }
        <Form.Control
          className={minValue ? 'active' : ''}
          placeholder={`Min ${placeholder}`}
          step={isFloat ? '0.1' : undefined}
          type={isFloat ? 'number' : undefined}
          value={allowPrependZero ? minValue : minValue || ''}
          onChange={(e) => {
            const val = e.target.value;
            if (!isFloat && val === '0') return;

            setFilterAttribute(minAttribute,
              val,
              { int: !percent && !float, float, percent }
            );
          }}
        />
      </InputGroup>
      <div className="px-1">-</div>
      <InputGroup>
        { addOn && <InputGroup.Text>{addOn}</InputGroup.Text> }
        <Form.Control
          className={maxValue ? 'active' : ''}
          placeholder={`Max ${placeholder}`}
          step={isFloat ? '0.1' : undefined}
          type={isFloat ? 'number' : undefined}
          value={allowPrependZero ? maxValue : maxValue || ''}
          onChange={(e) => {
            const val = e.target.value;
            if (!isFloat && val === '0') return;

            setFilterAttribute(maxAttribute,
              val,
              { int: !percent && !float, float, percent }
            );
          }}
        />
      </InputGroup>
    </div>
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(RangeInput);
